import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';

const OPERATOR_LABELS = {
  equals: '=',
  not_equals: '≠',
  contains: '~',
  exists: '∃',
};

export default function ConditionEdge({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data, style, markerEnd }) {
  const [edgePath, labelX, labelY] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
  const condition = data?.condition;
  const isReplace = data?.behavior === 'replace';
  const isSlot = data?.edgeKind === 'slot';
  const showLabel = isSlot || condition || isReplace;

  return (
    <>
      <BaseEdge id={id} path={edgePath} style={style} markerEnd={markerEnd} />
      {showLabel && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
              zIndex: 10,
            }}
            className="nodrag nopan"
          >
            <div style={{
              background: data?.exclusive ? '#3a2a1a' : '#1e1e2e',
              border: `1px solid ${data?.exclusive ? '#e0b07a' : '#555'}`,
              borderRadius: 4,
              padding: '2px 6px',
              fontSize: 9,
              fontFamily: 'monospace',
              color: data?.exclusive ? '#e0b07a' : '#aaa',
              whiteSpace: 'nowrap',
              maxWidth: 160,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
              {data?.exclusive && <span style={{ marginRight: 4 }}>⊗</span>}
              {isSlot
                ? <span style={{ fontFamily: 'monospace', color: '#0891b2', fontWeight: 'bold' }}>{`{{ ${data.slotName} }}`}</span>
                : (
                  <>
                    {condition
                      ? condition.operator === 'exists'
                        ? `${condition.field} exists`
                        : `${condition.field} ${OPERATOR_LABELS[condition.operator] || condition.operator} ${condition.value}`
                      : null}
                    {isReplace && <span style={{ marginLeft: condition ? 4 : 0, color: '#f07a7a' }}>↺ replace</span>}
                  </>
                )}
            </div>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
